import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadTraits from './traits';

export default grapesjs.plugins.add('permission', (editor, opts = {}) => {
  const default_types = {
    permissionButton: 'permission',
  };
  const default_labels = {
    permissionButton: 'Permissions',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Forms',
    },
    ...opts,
  };

  loadComponents(editor, options);
  loadTraits(editor, options);
});
